import React, { useEffect, useState } from "react";
import "../../_css/ReviewAns.css";
import { useNavigate, useParams } from "react-router-dom";
import { notifyError } from "../helper/Toaster";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { getQueAns } from "../../requests";
import InlineMarksEditor from "./InlineMarksEditor";

const QASheet = ({
  fn,
  refresh,
  setQuestions,
  aiEvalId,
  id,
  inlineEditMarks = false,
  setRefresh,
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [data, setData] = useState([])
  const [filterLowConfidence, setFilterLowConfidence] = useState(false);

  // const {id} = useParams()


  const get_answer_sheet = async () =>{
    if (!id) return;
    dispatch(startLoader())
    try {
      const res = await getQueAns({id})
      // console.log(res.data.data);
      setData(res.data.data)

      console.log(res.data.data)
      
      const len = res.data.data.length;


      const questions = [{id:0, question:"All Questions"}]

     res.data.data.forEach((e,i)=>{
      questions.push({id:e.id, question:`${e.question_no}`})
     })


      setQuestions([...questions])
    } catch (error) {
      notifyError("Something went wrong")
      console.log(error);
      
      
    } finally{
      dispatch(stopLoader())
    }
  }

  //smooth scroll to the question in the div with class name review-ans-con
  useEffect(()=>{

    if(aiEvalId){

      const questionIndex = data.findIndex((e)=>e.id == aiEvalId)
      if(questionIndex != -1){
        const reviewAnsCon = document.querySelector(".review-q-ans-con")
        reviewAnsCon.scrollTo({
          top: questionIndex * 210,
          behavior: "smooth"
        })
      }
    }


  },[aiEvalId,data])


  useEffect(()=>{

    get_answer_sheet()
   
    

  },[refresh, id])
  
  

  // Filter data based on low confidence
  const filteredData = filterLowConfidence
    ? data.filter((e) => e.low_confidence_flag === true)
    : data;

  // Count low confidence questions
  const lowConfidenceCount = data.filter((e) => e.low_confidence_flag === true).length;

  

  return (
    <>
      {/* Filter controls */}
      {lowConfidenceCount > 0 && (
        <div className="qa-filter-controls">
          <label className="qa-filter-checkbox">
            <input
              type="checkbox"
              checked={filterLowConfidence}
              onChange={(e) => setFilterLowConfidence(e.target.checked)}
            />
            <span>Show only questions requiring review ({lowConfidenceCount})</span>
          </label>
        </div>
      )}
    
    <div className="review-q-ans-con">
      { filteredData?.length > 0 && filteredData.map ((e,i)=>(
          <div key={i} className="review-ans-con">
        <div className="review-q-ans">
          <div className="review-q">
            <div className="review-q-header">
              
              <span>{e?.top_section?.split(" ")?.[1] && `${e.top_section.split(" ")[1]}-`} {e?.question_no} - {e?.question}</span>
              <div className="review-q-badges">
                {/* Question type badge */}
                {/* {e.question_type && e.question_type !== 'text' && (
                  <span className="question-type-badge">
                    {e.question_type}
                  </span>
                )} */}
                {/* Vision evaluation badge */}
                {e.evaluated_by === 'vision' && (
                  <span className="evaluation-badge evaluation-vision">
                    Diagram
                  </span>
                )}
                {/* Low confidence warning */}
                {e.low_confidence_flag && (
                  <span 
                    className="confidence-badge confidence-low" 
                    title={e.low_confidence_reason || `AI Confidence: ${e.confidence ? (e.confidence * 100).toFixed(0) + '%' : 'Low'}`}
                  >
                    Review Required
                    {e.low_confidence_reason && (
                      <span className="confidence-info-icon" title={e.low_confidence_reason}>
                        ℹ️
                      </span>
                    )}
                  </span>
                )}
              </div>
            </div>
            {inlineEditMarks ? (
              <InlineMarksEditor
                questionId={e.id}
                aiMarks={e.obt_marks}
                maxMarks={e.marks}
                remarks={e.remarks}
                setRefresh={setRefresh}
              />
            ) : (
              <div className="review-q-ai">
                AI Marks - {Number(e.obt_marks)}/{Number(e.marks)}
              </div>
            )}
          </div>
          <div className="review-ans">
           Ans - {e.student_answer}
          </div>
        { e?.remarks && <div style ={{fontStyle:"italic", fontSize:"14px"}}>
            Teacher feedback - {e.remarks}
          </div>}
        </div>
        { fn && (
          <div
            className="review-ans-view"
            onClick={() => fn(`Q${e.question_no}`, e.id)}
          >
            View
          </div>
        )}
      </div>
      ))}

      {filteredData?.length === 0 && filterLowConfidence && (
        <div className="no-data-message">
          No questions requiring review. All AI evaluations are confident!
        </div>
      )}
    
    </div>
    </>
  );
};

export default QASheet;
